import { WebFilter } from '@foxeet/utils/classes';
import { FilterModel } from '@foxeet/domain';

export class AppraisalDocumentListFilterComponent extends WebFilter {
  constructor(filterName: string, defaultFilter?: FilterModel) {
    super(filterName, defaultFilter);
  }
}
